import { UseMutationOptions, UseMutationResult, useMutation } from "@tanstack/react-query";
import { WorkerSSNResponse, createWorkerSSNView } from "src/api/workerSSN";
import { handleApiError } from "src/utils/errors";

export interface CreateWorkerSSNViewPayload {
  workerId: string;
  isWorkerAllowedToViewFullSSN: boolean;
}
/**
 * @description use this hook to get worker ssn, depending on the permission the user have this hooks
 * returns either full ssn or partial ssn
 */
export const useCreateWorkerSSNView = (
  options: UseMutationOptions<WorkerSSNResponse, Error, CreateWorkerSSNViewPayload> = {}
): UseMutationResult<WorkerSSNResponse, Error, CreateWorkerSSNViewPayload> => {
  return useMutation({
    mutationFn: createWorkerSSNView,
    onError: (error: Error) => handleApiError(error),
    ...options,
  });
};
